import React, { useState, useEffect } from 'react';
import { db, collection, onSnapshot } from '../../config/firebase';
import {VscAccount} from 'react-icons/vsc';
import {TbDiscountCheckFilled} from 'react-icons/tb';
import {PiClockCountdownFill} from 'react-icons/pi';
export default function StudentCount() {
  const [data, setData] = useState([]);

  useEffect(() => {
    const q = collection(db, 'Students');
    const unsubscribe = onSnapshot(q, (snapshot) => {
      setData(snapshot.docs.map((doc) => doc.data()));
    });

    return () => unsubscribe();
  }, []);

  const getStatusCount = (status) => {
    if (status === 'Total Students') {
      return data.length;
    } else {
      return data.filter((item) => item.status.toLowerCase() === status.toLowerCase()).length;
    }
  };
  
  return (
    <div className="grid grid-cols-1 mt-[60px] sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
    {[
        { text: 'Total Students',icon:<VscAccount color='purple'  size={'30'} /> ,count: data.length },
        { text: 'Approved Students',icon:<TbDiscountCheckFilled color='purple'  size={'30'} />, count: getStatusCount('approved') },
        { text: 'Pending Students',icon:<PiClockCountdownFill color='purple'  size={'30'} /> ,count: getStatusCount('pending') },
      ].map((item, index) => (
        <div
          key={index}
          className="flex items-center justify-center h-auto rounded bg-gray-50 dark:bg-gray-800 shadow-lg bg-sky-500/100"
        >
          <div className="border-2 border-gray-200 px-4 py-6 rounded-lg w-full flex justify-center flex-col items-center">
            {item.icon}
            <h2 className="title-font mt-4   font-medium text-3xl text-gray-900">{item.count}</h2>
            <p className="leading-relaxed">{item.text}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
